// Central export for all stores
export { useUserStore } from './userStore';
export { useActivityStore } from './activityStore';
export { useScoreStore } from './scoreStore';
export { useNetworkStore } from './networkStore';

// CBS (Contract Broiler System) stores
export { useCBSBatchStore } from './cbsBatchStore';
export { useCBSDailyRecordStore } from './cbsDailyRecordStore';
export { useCBSScoreStore } from './cbsScoreStore';

export type { UserProfile } from './userStore';
export type { Activity } from './activityStore';
export type { ScoreData } from './scoreStore';
export type { Connection, Post } from './networkStore';

// Clear all stores utility
import { useUserStore } from './userStore';
import { useActivityStore } from './activityStore';
import { useScoreStore } from './scoreStore';
import { useNetworkStore } from './networkStore';
import { useCBSBatchStore } from './cbsBatchStore';
import { useCBSDailyRecordStore } from './cbsDailyRecordStore';
import { useCBSScoreStore } from './cbsScoreStore';

export const clearAllStores = () => {
  useUserStore.getState().clearProfile();
  useActivityStore.getState().clearActivities();
  useScoreStore.getState().clearScore();
  useNetworkStore.getState().clearNetwork();
  useCBSBatchStore.getState().clearBatches();
  useCBSDailyRecordStore.getState().clearRecords();
  useCBSScoreStore.getState().clearScores();
};
